import { FC, memo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { TTranslate } from 'src/types/main';
import { getTranslate } from 'src/utils/helpers';
import { confirmDelete } from 'src/utils/modalConfirmations';
import Icon from 'src/view/components/Controls/Icon/Icon';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import IntegrationTooltip from 'src/view/components/IntegrationTooltip/IntegrationTooltip';
import branchEditStore from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/store/branchEditStore';
import { IEditableBranchSectionTable } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import './style.scss';

interface IProps {
  sectionId: number;
  sectionName: TTranslate;
  sectionTables: IEditableBranchSectionTable[];
  restrictionAccess: RESTRICTION_ACCESS | undefined;
  disabledForEditing: boolean;
}

const SectionListRow: FC<IProps> = ({ sectionId, sectionName, sectionTables, restrictionAccess, disabledForEditing }): JSX.Element => {
  const onPressDelete = () => {
    confirmDelete({
      title: localeStore.t('delete_section_question'),
      message: localeStore.t('confirm_deleting_section_text'),
      onConfirm: () => branchEditStore.removeBranchSection(sectionId),
    });
  };

  const showDineInSectionModal = () => {
    modalStore.openDineInSectionModal({
      id: sectionId,
      name: sectionName,
      tables: sectionTables,
      restrictionAccess,
      disabledForEditing,
      onSave: branchEditStore.updateBranchSections,
    });
  };

  return (
    <div className="section-list-row">
      <div className="family-medium text-size-16 cursor-pointer py-4 w-60" onClick={showDineInSectionModal}>
        {getTranslate(sectionName)}
      </div>
      <div className="d-flex justify-content-between px-4 w-40">
        <div className="family-medium text-size-16">{sectionTables.length}</div>
        <IntegrationManager setting={restrictionAccess} withTooltip tooltipOptions={{ minWidth: 350 }}>
          <IntegrationTooltip isVisible={disabledForEditing}>
            <Icon name={Icons.Trash} size={24} className="section-list-row__delete-btn" onPress={onPressDelete} />
          </IntegrationTooltip>
        </IntegrationManager>
      </div>
    </div>
  );
};

export default memo(SectionListRow);
